import styled, { css } from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
export const TextRoot = styled.span `
  ${({ align, bold, theme, isTitle, uppercase, size: appSize }) => {
    const variant = theme.typography.text[appSize];
    return css `
      font-family: ${theme.typography.fontFamily};
      font-size: ${variant.fontSize};
      font-weight: ${bold || isTitle
        ? variant.fontWeight
        : theme.typography.fontWeight};
      letter-spacing: ${isTitle ? variant.letterSpacing : 1};
      text-align: ${align};
      text-transform: ${uppercase ? 'uppercase' : 'none'};
    `;
}}
`;
//# sourceMappingURL=Text.styled.js.map